import { Pipe, PipeTransform } from '@angular/core';
import { isObservable, of } from 'rxjs';
import { map, startWith, catchError } from 'rxjs/operators';

@Pipe({
  name: 'loading',
  standalone: false,
})
export class LoadingPipe implements PipeTransform {
  transform(val) {
    return isObservable(val)
      ? val.pipe(
          map((value: any) => {
            if (value.error) {
              return {
                loading: value.type === 'start',
                error: value.error,
              };
            }
            return {
              loading: value.type === 'start',
              value: value.type ? value.value : value,
            };
          }),
          startWith({ loading: true }),
          catchError(error => of({ loading: false, error }))
        )
      : val;
  }
}
